







import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Helpers
import { parseBase64 } from '@/helpers/image'

@Component
export default class ImageViewer extends Vue {
  imageSrc: string = null
  isLoading = false

  @Getter('token') token

  @Prop({ type: Object }) data !: { value: string, proovCode: string }

  @Prop({ type: Boolean, default: false }) reload: boolean

  @Watch('data', { immediate: true })
  async fetchImage(data) {
    await this.loadImage()
  }

  @Watch('reload')
  async reloadImage(reload) {
    if (reload) {
      await this.loadImage()
    }
  }

  async loadImage() {
    if (!this.data && !this.data.value) {
      return
    }
    try {
      this.isLoading = true
      const res = await this.$api.image.getImageFromHash(this.token, this.data.value, true)
      this.imageSrc = parseBase64(res.data)
      this.$emit('loaded', this.imageSrc)
    } finally {
      this.isLoading = false
    }
  }
}
